<template>
    <div class="timeslots booking-summary pt-2">
        <div class="d-flex flex-column align-items-start">
            <span class="text-default">
                Name: <span class="font-weight-bold">{{clientName}}</span>
            </span>
            <span class="text-default">
                Appointment Date: <span class="font-weight-bold">{{formattedStartDate}}</span>
            </span>
            <span class="text-default">
                Appointment Time: <span class="font-weight-bold">{{formattedStartTime}}</span>
            </span>
            <div v-if="storeCardOnly" class="mt-3">
                <display-refund-alert v-if="providerTypeId == 1"></display-refund-alert>
            </div>
            <span v-else-if="deposityOnly" class="text-default">
                Total Deposit: <span class="font-weight-bold">{{currencySymbol}}{{amount.toFixed(2).toString()}}</span>
            </span>
            <span v-else-if="fullAmount" class="text-default">
                Total: <span class="font-weight-bold">{{currencySymbol}}{{amount.toFixed(2).toString()}}</span>
            </span>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
    import { BookingPaymentDateTimeMixin } from '@/mixins/BookingPayment/BookingPaymentDateTimeMixin';
    import { CountryCacheMixin } from '@/mixins/Booking/CountryCacheMixin'
    import DisplayRefundAlert from './DisplayRefundAlert.vue';

    export default {
        name: 'PaymentSummary',
        mixins: [BookingPaymentDateTimeMixin, CountryCacheMixin],
        computed: {
            clientName(){
                return !!this.bookingPayment ? this.bookingPayment.clientName : ''
            },
            amount() {
                return !!this.bookingPayment ? this.bookingPayment.amount : 0;
            },
            currency() {
                return !!this.bookingPayment ? this.bookingPayment.currency : ''
            },
            currencySymbol() {
                const { currency, currencySymbol } = this.country || {};
                return currency === this.currency ? currencySymbol : `${this.currency} `;
            },
            paymentType(){
                return !!this.bookingPayment ? this.bookingPayment.paymentType : null;
            },
            storeCardOnly(){
                return !!this.paymentType ? this.paymentType.id == 1 : false;
            },
            deposityOnly(){
                return !!this.paymentType ? this.paymentType.id == 2 : false;
            },
            fullAmount(){
                return !!this.paymentType ? this.paymentType.id == 3 : false;
            },
            providerTypeId() {
                return !!this.bookingPayment ? this.bookingPayment.providerTypeId : 0;
            }
        },
        components: {
            'display-refund-alert': DisplayRefundAlert
        }
    }
</script>